import { styled } from '@mui/material';
import {
  GridCompact12,
  GridContainer
} from 'components/shared/Grid/Grid.components';

export const FormWrapper = styled(GridCompact12)({
  flex: 1,
  minHeight: 0,
  overflow: 'hidden'
});

export const FormContentGrid = styled(GridContainer)({
  minHeight: 0,
  maxHeight: '100%',
  overflowY: 'auto'
});
